import { NoddiSpinner } from '../../../atoms';

export const NoddiSpinnerWithText = ({ classname, loadingText }: { classname?: string; loadingText?: string }) => (
  <NoddiSpinner size='medium' className={classname}>
    {loadingText ?? 'Loading'}...
  </NoddiSpinner>
);
